(function () {
  // ─── SECTION REVEAL ─────────────────────────────────
  const io = new IntersectionObserver((entries) => {
    for (const e of entries) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    }
  }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });

  const revealSelectors = [
    '.hero-left .hero-eyebrow', '.hero h1', '.hero-sub', '.hero-cta', '.hero-stats',
    '.hero-right',
    '.intro-strip .eyebrow', '.intro-strip .stmt', '.intro-strip .marks',
    '.products-head', '.product', '.compare-card',
    '.lookbook-head', '.lookbook-strip .lk',
    '.promise-inner > *', '.promise-grid .cell',
    '.founder .eyebrow', '.founder .q', '.founder .sig',
    '.foot-brand', '.foot-col',
    '.pdp-gallery', '.pdp-info',
    '.cart-head', '.cart-items', '.cart-summary'
  ];

  revealSelectors.forEach(sel => {
    document.querySelectorAll(sel).forEach((el, i) => {
      el.classList.add('reveal');
      const d = (i % 4);
      if (d > 0) el.classList.add('d' + d);
      io.observe(el);
    });
  });

  // ─── HERO PARALLAX ──────────────────────────────────
  const heroImg = document.querySelector('.hero-right img');
  if (heroImg) {
    let ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = Math.min(window.scrollY * 0.16, 140);
        heroImg.style.translate = '0 ' + y + 'px';
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ─── MOBILE NAV ─────────────────────────────────────
  const hamburger = document.querySelector('.nav-hamburger');
  const mobileNav = document.querySelector('.nav-mobile');
  const closeBtn = document.querySelector('.nav-mobile-close');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => mobileNav.classList.add('open'));
    if (closeBtn) closeBtn.addEventListener('click', () => mobileNav.classList.remove('open'));
    mobileNav.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => mobileNav.classList.remove('open'));
    });
  }

  // ─── PDP GALLERY THUMBNAILS ──────────────────────────
  const mainImg = document.querySelector('.pdp-gallery-main img');
  document.querySelectorAll('.pdp-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.pdp-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg) {
        const src = thumb.querySelector('img')?.src;
        if (src) { mainImg.src = src; mainImg.style.opacity = '0'; setTimeout(() => mainImg.style.opacity = '1', 10); }
      }
    });
  });

  // ─── CART QUANTITY ───────────────────────────────────
  document.querySelectorAll('.cart-item-qty, .pdp-qty').forEach(qtyEl => {
    const input = qtyEl.querySelector('input');
    qtyEl.querySelector('.qty-minus')?.addEventListener('click', () => {
      const v = parseInt(input.value, 10);
      if (v > 1) input.value = v - 1;
      input.dispatchEvent(new Event('change'));
    });
    qtyEl.querySelector('.qty-plus')?.addEventListener('click', () => {
      input.value = parseInt(input.value, 10) + 1;
      input.dispatchEvent(new Event('change'));
    });
  });

  // ─── CART REMOVE (AJAX) ──────────────────────────────
  document.querySelectorAll('.js-remove-item').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const key = btn.dataset.key;
      if (!key) return;
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      if (res.ok) window.location.reload();
    });
  });

  // ─── CART QTY UPDATE (AJAX) ──────────────────────────
  document.querySelectorAll('.js-cart-qty').forEach(input => {
    input.addEventListener('change', async () => {
      const key = input.dataset.key;
      const qty = parseInt(input.value, 10);
      if (!key || isNaN(qty)) return;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      window.location.reload();
    });
  });

  // ─── CART COUNT IN NAV ───────────────────────────────
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const bagEl = document.querySelector('.bag');
      if (bagEl) bagEl.textContent = 'BAG · ' + cart.item_count;
    })
    .catch(() => {});

})();
